import React, {useState} from 'react';
import _ from "lodash";
import {Button, Checkbox, Input, Popover} from "antd";
import {EditOutlined} from "@ant-design/icons";
import User from "./User";
import Spacer from "./Spacer";

export default ({g, t, score, admin, onChange, max, disabled, allow, type, withForfeit, withWithdraw, forfeit, ...props}) => {
  let [newForfeit, setForfeit] = useState(forfeit);
  let [open, setOpen] = useState(false);

  if (admin === false || (admin !== true && User.viewer && !allow))
    return <Input value={score} disabled/>;

  let scoreBtn = (t, n, block) => {
    let click = () => {
      onChange(t, n, newForfeit);
      setOpen(false);
    }

    if (block)
      return <td key={n} colSpan={5} onClick={click}>{n}</td>
    else
      return <td key={n} onClick={click}>{n}</td>
  };

  let btnRow = (t, from, count = 5) => <tr key={from}>
    {_.times(count, n => scoreBtn(t, from + n))}
  </tr>

  let popoverContent = t => {
    if (max > 11)
      return <div>
        {withWithdraw && scoreBtn(t, "Withdraw", true)}
        {/*{btnRow(t, 0, 4)}*/}
        {/*{btnRow(t, 4, 4)}*/}
        {/*{btnRow(t, 8, 4)}*/}
        {/*{btnRow(t, 12, 4)}*/}
        {btnRow(t, 0, 5)}
        {btnRow(t, 5, 5)}
        {btnRow(t, 10, 5)}
        {btnRow(t, 15, 5)}
        {max >= 15 && btnRow(t, 20, 5)}
        {max >= 20 && btnRow(t, 25, 5)}
        {max >= 20 && btnRow(t, 30, 5)}
      </div>
    else
      return <div>
        {btnRow(t, 0, 4)}
        {btnRow(t, 4, 4)}
        {btnRow(t, 8, 4)}
      </div>
  }

  let vChange = () => {
    setOpen(!open);
  }

  let applyForfeit = newForfeit => {
    onChange(t, score.replace ? parseInt(score.replace(/F/, "")) : score, newForfeit);
    setForfeit(newForfeit);
  }

  let clear = () => {
    onChange(t, null, null);
    setOpen(false);
  }

  let title = <div className="flex justify-between  ">
    {score ? <Button danger type="text" size="small" onClick={clear}>clear score</Button> : <div>Set Score</div>}
    {withForfeit && <div><Checkbox checked={newForfeit} onChange={() => applyForfeit(!forfeit)}>Forfeit</Checkbox></div>}
  </div>

  let view = score;
  if (typeof(score) !== 'number') {
    view = score || <EditOutlined/>;
  }

  return <Popover placement="left" trigger="click" visible={open && !disabled} onVisibleChange={vChange} content={popoverContent(t)} overlayClassName="scores-popover" title={title}>
    <Button disabled={disabled} className={type || "score-btn"}>{view}</Button>
  </Popover>
}


